import { Avatar } from '@mui/material';

import DeviceIcons from '../Icons/DeviceIcons';

interface DeviceImageProps {
    desktop?: boolean;
    imageName: string | undefined | null;
    size?: number;
}

export default function DeviceImage({ desktop, imageName, size = 120 }: Readonly<DeviceImageProps>): React.JSX.Element {
    const imageUrl = `${process.env.EXPO_PUBLIC_DEVICE_BUCKET_URL!}/${imageName!}`;

    const icon = desktop ? DeviceIcons[5] : DeviceIcons[0];

    return imageName ? (
        <img
            alt={imageName}
            src={imageUrl}
            style={{
                backgroundColor: 'transparent',
                height: `${size.toString()}px`,
                mixBlendMode: 'multiply',
                objectFit: 'contain',
                width: `${size.toString()}px`,
            }}
        />
    ) : (
        <Avatar
            sx={{
                bgcolor: 'transparent',
                color: 'primary.main',
                height: size,
                p: 1,
                width: size,
            }}
        >
            {icon}
        </Avatar>
    );
}
